<div
  class="cre-wig-bonus-tab"
  *ngIf="
    (this.bonusPayableMonths === null ||
      (this.bonusPayableMonths && this.bonusPayableMonths.length === 0)) &&
    !isLoading
  "
>
  <div class="cre-wig-bonus-body">
    You are eligible for the bonus starting with trips dispatched
    {{ this.optInInfo.secondMonth }} 1. Your {{ this.optInInfo.firstMonth }} performance on the
    criteria below will determine how much of the bonus you earn in
    {{ this.optInInfo.secondMonth }}.
  </div>
  <div class="cre-wig-bonus-body displayable-stats">
    <div class="displayable-stats bullet-list">No Accidents or Critical Events</div>
    <div class="displayable-stats bullet-list">No Lates</div>
    <div class="displayable-stats bullet-list">All Commitments, WIG Huddles, and Safety Video</div>
  </div>
</div>
<div *ngIf="!!monthList">
  <app-expandable-panel [cardType]="true">
    <div
      class="cre-wig-monthly-competition-details-carousel-control"
      *ngIf="monthList != null && monthList.length > 0"
    >
      <div
        class="cre-wig-monthly-competition-details-carousel-control-button"
        (click)="previousMonth()"
      >
        <fa-icon [icon]="['fas', 'caret-left']"></fa-icon>
      </div>
      <span
        class="cre-wig-monthly-competition-details-title"
        *ngIf="!!monthList[currentMonthIndex]"
      >
        {{ monthList[currentMonthIndex].description }}
      </span>
      <div
        class="cre-wig-monthly-competition-details-carousel-control-button"
        (click)="nextMonth()"
      >
        <fa-icon [icon]="['fas', 'caret-right']"></fa-icon>
      </div>
    </div>
  </app-expandable-panel>
  <div>
    <p-carousel
      [page]="currentMonthIndex"
      [numVisible]="1"
      [value]="monthList"
      #monthlyStatsCarousel
    >
      <ng-template let-month pTemplate="item">
        <app-wig-bonus-summary
          [bonusInformation]="bonusInformation"
          [bonusStat]="bonusStats[month.startDate]"
          [currentPeriod]="currentPeriod + 'T00:00:00'"
          [paymentType]="paymentUnit"
          [qualifyPeriod]="month.startDate"
        >
        </app-wig-bonus-summary>
      </ng-template>
    </p-carousel>
  </div>
</div>

<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" [hidden]="!isLoading"></cre-spinner>
</div>

<p-sidebar
  [(visible)]="isSidebarVisible"
  [showCloseIcon]="false"
  position="bottom"
  styleClass="cre-wig-bonus-enrollment-sidebar"
>
  <div class="cre-wig-bonus-enrollment-sidebar-icon" *ngIf="isSidebarVisible">
    <fa-icon (click)="hideSidebar()" [icon]="['fal', 'times']" [size]="'3x'"> </fa-icon>
  </div>
  <div class="cre-wig-bonus-enrollment-sidebar-header">Enrollment Confirmation</div>
  <div class="cre-wig-bonus-enrollment-sidebar-body">
    I agree that by enrolling in the bonus program, my current pay will be reduced by 2 CPM (split
    if team) regardless of how much I earn on the bonus. This reduction in current pay is permanent
    and cannot be revoked. I understand my level of achievement of the bonus depends upon my
    performance on the criteria established. I further agree that my enrollment will constitute an
    amendment to any prior agreements entered into between me and the company relating to my
    compensation.
  </div>
  <div>
    <button pButton class="cre-wig-bonus-cancel" label="CANCEL" (click)="hideSidebar()"></button>
    <button pButton class="cre-wig-bonus-confirm" label="ENROLL" (click)="optIn()"></button>
  </div>
</p-sidebar>

<p class="bonus-text-legal-pay-type">{{ legalPayType }}</p>
